import styled, { keyframes } from "styled-components";
import { ReactComponent as ChevronDownSvg } from "../../assets/icons/chevron-down.svg";
const shimmer = keyframes`
  0% { background-position: -500px 0; }
  100% { background-position: 500px 0; }
`;
export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Title = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 26px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.1px;

  display: -webkit-box;
  -webkit-line-clamp: 2; /* Maksimalno 2 reda */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  overflow-x: auto;
`;

export const Tab = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  outline: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.075px;
  opacity: ${(p) => (p.$active ? 1 : 0.6)};
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ShareButton = styled.button`
  cursor: pointer;
  display: inline-flex;
  outline: none;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  border: 1px solid #0e4a96;
  color: white;
  background: linear-gradient(176deg, #05224f 3.6%, #0f4e9e 96.4%);
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.065px;
  box-shadow: 0 4px 24px 0 #081120;
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  min-width: 0;
`;

export const StatIcon = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const Stat = styled.div`
  display: flex;
  padding: 8px 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 14px;
  border: 1px solid #142743;
  background: #0b1727;
  flex: 1 0 0;
`;

export const InfoContainer = styled.div`
  margin-top: ${(p) => (p.$marginTop ? "-24px" : "0px")};
  display: flex;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 14px;
  border: 1px solid #142743;
  background: #0b1727;
  width: 100%;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  /* align-items: center; */
  justify-content: space-between;
  width: 100%;
  gap: 40px;
  @media (max-width: 768px) {
    gap: 2px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const InfoLabel = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-family: Figtree;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.06px;
`;

export const InfoValue = styled.span`
  color: white;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.06px;
  text-align: right;
  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const StatValue = styled.span`
  color: white;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.09px;
`;

export const StatLabel = styled(InfoLabel)`
  z-index: 1;
  color: #999;
`;

export const Tags = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const Tag = styled.span`
  display: flex;
  white-space: nowrap;
  height: 22px;
  padding: 0px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #142743;
  background: #142743;
  color: rgba(255, 255, 255, 0.7);
  font-family: Figtree;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -0.06px;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin: 0 auto;
  width: 100%;
  flex: 1;
  align-items: start;
  /* max-width: 1200px; */

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const ToastWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const CopyContainer = styled.div`
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #213d64;
  background: #0e1c31;
  cursor: pointer;

  transition: all 0.2s ease-in-out;
  &:hover {
    background: #1d1d1e;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "auto"};
  position: relative;
  background: linear-gradient(180deg, #162b49 0%, #0f1e34 100%);
  border-radius: 12px;
  width: 100%;

  /* &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 12px;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 1000px 100%;
    animation: ${shimmer} 2.5s ease-in-out infinite forwards;
  } */

  @media (max-width: 1024px) {
    height: ${(p) => (p.$skeleton ? "100%" : "unset")};
    max-height: ${(p) => (p.$skeleton ? "1000px" : "unset")};
  }
`;

export const MainImg = styled.img`
  width: 100%;
  border-radius: 12px;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "auto"};
  opacity: ${({ $loaded }) => ($loaded ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

export const MainVideo = styled.video`
  width: 100%;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "auto"};
  border-radius: 12px;
  object-fit: cover;
  opacity: ${({ $loaded }) => ($loaded ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

export const MediaSkeleton = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 12px;
  background: linear-gradient(180deg, #162b49 0%, #0f1e34 100%);
  overflow: hidden;
  pointer-events: none;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 1000px 100%;
    animation: ${shimmer} 2.5s ease-in-out infinite forwards;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 16px;
  margin-left: -4px;
`;

export const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  width: 100%;
  flex-wrap: wrap;
`;

// =============================================
// Generation Section Styles (shared)
// =============================================

export const GenerationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const GenerationTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;
`;

// =============================================
// Video Generation Styles
// =============================================

export const GenerationTabsContainer = styled.div`
  height: 36px;
  border-radius: 100px;
  background: #345884;
  display: flex;
  padding: 2px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 2px;
    left: ${({ $activeTab }) =>
      $activeTab === "IMAGE_TO_VIDEO" ? "2px" : "calc(50% + 1px)"};
    width: calc(50% - 2px);
    height: calc(100% - 4px);
    background: white;
    border-radius: 100px;
    transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
  }
`;

export const GenerationTab = styled.div`
  flex: 1;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 100px;
  cursor: pointer;
  position: relative;
  z-index: 2;
  transition: all 0.2s ease;
`;

export const GenerationTabText = styled.p`
  color: ${({ $selected }) => ($selected ? "#142743" : "white")};
  font-family: Figtree;
  font-size: 13px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.065px;
  transition: color 0.2s ease;
`;

// =============================================
// Upload Area (shared between video & image)
// =============================================

export const UploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 14px;
  border: 1.5px dashed #345884;
  background: #0b1727;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  min-height: 250px;

  &:hover {
    border-color: #45608d;
    background: #0e1c31;
  }
`;

export const UploadedPreview = styled.img`
  width: 100%;
  max-width: 320px;
  min-height: 250px;
  object-fit: contain;
`;

export const UploadedVideoPreview = styled.video`
  width: 100%;
  max-width: 320px;
  min-height: 250px;
  object-fit: contain;
`;

export const PreviewDeleteButton = styled.button`
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;
  width: 36px;
  height: 36px;
  padding-bottom: 2px;

  svg {
    path {
      stroke: white;
    }
  }
`;

export const PreviewCropButton = styled.button`
  display: flex;
  align-items: center;
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 6px;
  outline: none;
  border: none;
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;

  svg {
    path {
      stroke: white;
    }
  }
`;

export const UploadIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UploadText = styled.p`
  color: rgba(255, 255, 255, 0.5);
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.065px;
  text-align: center;
`;

export const UploadHint = styled.p`
  color: rgba(255, 255, 255, 0.3);
  font-family: Figtree;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: -0.055px;
`;

export const UploadGalleryButton = styled.button`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.07px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  transition:
    color 0.2s ease,
    opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

// =============================================
// Checkbox / Nudify Row (shared)
// =============================================

export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

export const CheckboxLabel = styled.span`
  position: relative;
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: -0.065px;
`;

export const NudifyContainer = styled.div`
  border-radius: 12px;
  background: #0e1c31;
  display: flex;
  padding: 6px 8px;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  align-self: stretch;
  flex-direction: row;
  height: 33px;
`;

export const NudifyText = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.065px;
`;

// =============================================
// Generate Row (shared)
// =============================================

export const GenerateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
`;

export const SettingsIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 24px;
  height: 24px;
`;

export const GenerateButton = styled.button`
  flex: 1;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  color: #0f2c32;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.065px;
  transition: all 0.15s ease;

  &:hover {
    background: #e4e4e7;
  }

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
    transform: none;
  }
`;

export const CreditBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #0f2c32;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: -0.065px;
`;

export const InfoIconButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  svg {
    path {
      stroke: ${(p) => (p.$active ? "rgba(63, 136, 247, 1)" : "#fff")};
    }
  }
`;

export const TooltipContainer = styled.div`
  border-radius: 16px;
  border: 1px solid #213d64;
  background: #081120;
  padding: 16px;
  position: absolute;
  bottom: calc(100% + 8px);
  right: 0;
  width: 300px;
  gap: 8px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    width: 260px;
    right: -8px;
  }
`;

export const TooltipText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.065px;
  opacity: ${(p) => (p.$light ? 0.56 : 1)};
`;

// =============================================
// Image Generation - Settings / Options
// =============================================

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const SettingsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const SettingsLabelText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.065px;
  text-align: left;
`;

export const SettingsInput = styled.input`
  display: flex;
  height: 40px;
  padding: 10px 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #0b1727;
  font-family: Figtree;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.065px;
  outline: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.35);
  }
`;

export const SettingsTextarea = styled.textarea`
  display: flex;
  padding: 10px 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #0b1727;
  font-family: Figtree;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.065px;
  resize: vertical;
  min-height: 80px;
  outline: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.35);
  }
`;

export const OptionCheckboxContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(2, auto);
  gap: 6px;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background: #213d64;
  }
  &::-webkit-scrollbar-thumb {
    background: #2877d9;
    border-radius: 20px;
  }
`;

export const OptionCheckboxRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  width: 100%;
`;

export const OptionCheckbox = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  height: 33px;
  border-radius: 10px;
  background: ${(p) => (p.$checked ? "transparent" : "#0e1c31")};
  border: ${(p) =>
    p.$checked ? "0.5px solid #2877d9" : "0.5px solid transparent"};
  transition: all 0.15s ease;
`;

export const OptionCheckboxText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.065px;
`;

export const AngleDropdownsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const AngleDropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const AngleDropdownTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #0e1c31;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  outline: none;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const AngleDropdownChevron = styled(ChevronDownSvg)`
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transform: ${(p) => (p.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  flex-shrink: 0;
`;

export const AngleDropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  padding: 6px;
  background: #0e1c31;
  border: 0.5px solid #325682;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  max-height: 240px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background: #45608d;
  }
  &::-webkit-scrollbar-thumb {
    background: #2877d9;
    border-radius: 20px;
  }
`;

export const AngleDropdownOption = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  background: ${(p) => (p.$selected ? "#213d64" : "transparent")};
  transition: background 0.15s ease;

  &:hover {
    background: #213d64;
  }
`;

// =============================================
// Tab Content / Masonry Grid Styles
// =============================================

export const TabContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  grid-column: 1 / -1;
`;

export const MasonryGrid = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
`;

export const MasonryColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  width: 100%;

  h3 {
    font-size: 20px;
    color: white;
    margin-bottom: 8px;
    font-family: Figtree;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;
    color: white;
    opacity: 0.5;
  }
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 8px;
`;

// =============================================
// Details Skeleton Styles
// =============================================

export const SkeletonBox = styled.div`
  background: linear-gradient(180deg, #162b49 0%, #0f1e34 100%);
  border-radius: ${(p) => p.$radius || "12px"};
  width: ${(p) => p.$width || "100%"};
  ${(p) => p.$maxWidth && `max-width: ${p.$maxWidth};`}
  height: ${(p) => (p.$aspectRatio ? "auto" : p.$height || "20px")};
  ${(p) => p.$aspectRatio && `aspect-ratio: ${p.$aspectRatio};`}
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 1000px 100%;
    animation: ${shimmer} 2.5s ease-in-out infinite forwards;
  }
`;
export const SkeletonBoxImage = styled.div`
  background: linear-gradient(180deg, #162b49 0%, #0f1e34 100%);
  border-radius: ${(p) => p.$radius || "12px"};
  width: 100%;
  flex: 1;
  position: relative;
  overflow: hidden;

  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || 0.7293447293447294};

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 12px;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 1000px 100%;
    animation: ${shimmer} 2.5s ease-in-out infinite forwards;
  }
`;

export const Badge = styled.div`
  transform: rotate(14.909deg);

  position: absolute;
  right: -24px;
  top: -8px;
`;
